/**
 * Angular bootstrapping
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';

/**
 * App Module
 * our top level module that holds all of our components
 */
import { AppModule } from './modules/app';

/**
 *  Import Raven-js for Sentry
 */
import Raven from 'raven-js';

/**
 * set up raven for error logging
 */
function initRavenJS(){
  if(SENTRY_DSN && SENTRY_ENABLED){
    //set default settings
    let config = {
      "allowDuplicates" : true,
      tags: {app_name: APP_NAME}
    }
    
    // set Sentry Environment
    config['environment']  = APP_ENV.toUpperCase();

    /*
    * Setup additional Sentry configuration here
    * see here: https://docs.sentry.io/clients/javascript/config/
    */
    if(APP_ENV != 'local') Raven.config(SENTRY_DSN, config).install();
  }
  
}

/**
 * Bootstrap our Angular app with a top level NgModule
 */
export function main(): Promise<any> {
  initRavenJS();
  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(environment.decorateModuleRef)
    .catch((err) => console.error(err));
}

/**
 * Needed for hmr
 * in prod this is replace for document ready
 */
switch (document.readyState) {
  case 'loading':
    document.addEventListener('DOMContentLoaded', _domReadyHandler, false);
    break;
  case 'interactive':
  case 'complete':
  default:
    main();
}

function _domReadyHandler() {
 document.removeEventListener('DOMContentLoaded', _domReadyHandler, false);
 main();
}
